// eslint-disable-next-line import/no-anonymous-default-export
export default {
  baseUrl: process.env.REACT_APP_API_BASE_URL,
  defaultTimeout: parseInt(process.env.REACT_APP_API_TIMEOUT, 10), // that 10 is a radix not a default
};
